<template>
  <Modal v-bind="{ ...$attrs, title: '修改' }" @open="onModalOpen" @cancel="onCancel" @confirm="onConfirm">
    <!-- 只有3.0显示切换，ada只有头像昵称及跳转页 -->
    <div class="ghost-button-styles" v-if="pageStates.isV3 || pageStates.isTemplate">
      <!-- 如果是单视频号版位，只显示视频号 -->
      <el-radio-group v-model="brandType" v-if="isChannels" @change="onTabChange">
        <el-radio-button ghost :label="BRAND_ENUM.CHANNEL">视频号</el-radio-button>
      </el-radio-group>
      <el-radio-group v-model="brandType" v-else @change="onTabChange">
        <el-radio-button ghost :label="BRAND_ENUM.BRAND">品牌跳转</el-radio-button>
        <el-radio-button ghost :disabled="isCreativeTemplateRewarded" :label="BRAND_ENUM.PROFILE"> 品牌简介页 </el-radio-button>
        <el-radio-button ghost :disabled="isCreativeTemplateRewarded" :label="BRAND_ENUM.CHANNEL">视频号</el-radio-button>
        <el-radio-button ghost :disabled="isCreativeTemplateRewarded" :label="BRAND_ENUM.OFFICIAL_ACCOUNT">公众号</el-radio-button>
      </el-radio-group>
    </div>

    <div v-loading="tableLoading">
      <!-- 头像昵称及跳转页， ada和3.0都需要 -->
      <ProfileTable v-if="brandType === BRAND_ENUM.PROFILE && profileList.length" v-model="profileId" v-bind="{ data: profileList }">
        <template v-slot:btns>
          <el-button @click="showAddModal" type="text">新建</el-button>
          <el-button @click="getProfileList" type="text">刷新</el-button>
        </template>
      </ProfileTable>

      <!-- 品牌形象，只有3.0需要 -->
      <BrandTable v-else-if="brandType === BRAND_ENUM.BRAND && brandList.length" v-model="brandId" v-bind="{ data: brandList }">
        <template v-slot:btns>
          <el-button @click="showAddBrandModal" type="text">新建</el-button>
          <el-button @click="getBrandList" type="text">刷新</el-button>
        </template>
      </BrandTable>

      <!-- 视频号，只有3.0需要 -->
      <PromotedChannelTable
        v-else-if="brandType === BRAND_ENUM.CHANNEL && channelPromotedObjectList.length"
        v-model="channelId"
        v-bind="{ data: channelPromotedObjectList }"
      >
      </PromotedChannelTable>

      <!-- 公众号，只有3.0需要 -->
      <PromotedChannelTable
        v-else-if="brandType === BRAND_ENUM.OFFICIAL_ACCOUNT && officialAccountList.length"
        v-model="officialAccountId"
        v-bind="{ data: officialAccountList }"
        col-label="公众号"
      >
      </PromotedChannelTable>

      <div v-else style="padding: 20px 0; text-align: center">
        <span>暂无数据&ensp;</span>
        <el-button v-if="brandType === BRAND_ENUM.PROFILE" type="text" @click="showAddModal">新建</el-button>
        <el-button v-if="brandType === BRAND_ENUM.BRAND" type="text" @click="showAddBrandModal">新建</el-button>
      </div>
    </div>

    <AddProfileModal v-model="addProfileModal" v-bind="addProfileData" @add-confirm="onAddConfirm"></AddProfileModal>

    <AddBrandModal v-model="addBrandModal" v-bind="addBrandData" @add-confirm="getBrandList"></AddBrandModal>
  </Modal>
</template>

<script>
import AddProfileModal from './profile/add-profile-modal.vue'
import AddBrandModal from './profile/add-brand-modal.vue'
import { getPromotedObject } from '@/api/tencent.model'
import { getProfiles, delProfiles, getBrands } from '@/api/tencent.local.model'
import { projectComputedMethods } from '../../../model/project-mixins.js'

import ProfileTable from './profile/profile-table.vue'
import BrandTable from './profile/brand-table.vue'
import PromotedChannelTable from './profile/promoted-channel-table.vue'

import Modal from './modal.vue'

import { BRAND_LIST, BRAND_ENUM, DELIVERY_MODE, DYNAMIC_CREATIVE_TYPE } from '../../../model/creative-const.js'

export default {
  components: { Modal, AddProfileModal, AddBrandModal, ProfileTable, BrandTable, PromotedChannelTable },
  props: {
    isChannels: {
      type: Boolean,
      default: false
    },
    currentRow: Object
  },
  data() {
    return {
      BRAND_LIST,
      BRAND_ENUM,

      addProfileModal: false,
      tableLoading: false,
      addProfileData: {},
      profileId: '',
      profileList: [],
      channelPromotedObjectList: [],
      officialAccountList: [],
      addBrandModal: false,
      addBrandData: {},
      brandId: '',
      brandList: [],
      // 默认品牌简介页
      brandType: BRAND_ENUM.BRAND,

      channelId: '',
      officialAccountId: ''
    }
  },
  computed: {
    //  pageStates
    ...projectComputedMethods,
    rawForm() {
      return this.currentRow || {}
    },
    /**
     * @description: 是否启用首评回复
     * @return {*}
     */
    isFirstCommentComponentEnable() {
      const { creative } = this.rawForm
      const { social_skill } = creative?.components || {}
      return social_skill?.social_skill_first_comment_switch
    },
    /**
     * @description: 是否是激励浏览广告创意形式
     * @return {*}
     */
    isCreativeTemplateRewarded() {
      const { creative } = this.rawForm
      const { delivery_mode, dynamic_creative_type } = creative || {}
      if (delivery_mode === DELIVERY_MODE.CUSTOMIZE) {
        return dynamic_creative_type === DYNAMIC_CREATIVE_TYPE.COMMON
      }
      return false
    }
  },
  methods: {
    onModalOpen() {
      // 如果是单视频号版位，选中视频号
      if (this.isChannels) {
        this.brandType = BRAND_ENUM.CHANNEL
      }

      // 腾讯广告3.0模板新建计划单独处理
      const { profile } = this.currentRow
      if (profile?.brandType) {
        this.brandType = profile?.brandType
      }

      // 开启了首评回复，切换到视频号
      // if (this.isFirstCommentComponentEnable) {
      //   this.brandType = BRAND_ENUM.CHANNEL
      // }

      // 激励浏览广告创意形式，切换到品牌形象
      if (this.isCreativeTemplateRewarded) {
        this.brandType = BRAND_ENUM.BRAND
      }

      this.onTabChange(this.brandType)
    },
    onConfirm() {
      let res = {}
      switch (this.brandType) {
        case BRAND_ENUM.PROFILE:
          res = this.profileList.find((p) => p.profile_id === this.profileId)
          break
        case BRAND_ENUM.BRAND:
          res = this.brandList.find((b) => b.brand_id === this.brandId)
          break
        case BRAND_ENUM.CHANNEL:
          res = this.channelPromotedObjectList.find((c) => c.promoted_object_id === this.channelId)
          break

        case BRAND_ENUM.OFFICIAL_ACCOUNT:
          res = this.officialAccountList.find((c) => c.promoted_object_id === this.officialAccountId)
          break
        default:
          break
      }

      this.$emit('confirm', res || {}, this.brandType)
      this.resetModel()
    },
    onCancel() {
      this.$emit('cancel')
      this.resetModel()
    },
    resetModel() {
      this.profileId = ''
      this.brandId = ''
      this.channelId = ''
      this.officialAccountId = ''
    },
    onTabChange(tab) {
      switch (tab) {
        case BRAND_ENUM.PROFILE:
          this.getProfileList()
          break
        case BRAND_ENUM.BRAND:
          this.getBrandList()
          break
        case BRAND_ENUM.CHANNEL:
          this.getChanneList()
          break
        case BRAND_ENUM.OFFICIAL_ACCOUNT:
          this.getOfficialAccountList()
          break
        default:
          break
      }
    },
    getBrandList() {
      const { account } = this.rawForm.plan
      const { profile } = this.rawForm
      const { brand } = this.rawForm.creative?.components || {}
      this.tableLoading = true

      // 3.0回显品牌形象
      let brandId = brand?.brandInfo?.brand_id || ''
      // 3.0模板新建回显品牌形象
      if (profile && profile.info) {
        brandId = profile.info.brand_id
      }

      getBrands({ ad_account_id: account.id })
        .then((data) => {
          this.brandList = data
          this.brandId = brandId
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    getProfileList() {
      const { account, promotedObject } = this.rawForm.plan
      const { profile } = this.rawForm
      const { brand } = this.rawForm.creative?.components || {}

      // 3.0回显品牌简介页
      let profileId = brand?.profileInfo?.profile_id || ''
      // 3.0模板新建回显品牌简介页
      if (profile && profile.info) {
        profileId = profile.info.profile_id
      }
      this.tableLoading = true
      getProfiles({
        ad_account_id: account.id,
        promoted_object_id: promotedObject.promoted_object_id
      })
        .then((data) => {
          this.profileList = data
          this.profileId = profileId
        })
        .finally(() => {
          this.tableLoading = false
        })
    },
    getChanneList() {
      const { account } = this.rawForm.plan
      const { wechat_channels } = this.rawForm.creative?.components || {}
      const { profile } = this.rawForm

      // 3.0回显视频号
      let channelId = wechat_channels?.channelInfo?.promoted_object_id || ''
      // 3.0模板新建回显视频号（配置品牌形象及落地页的弹窗）
      if (profile && profile.info) {
        channelId = profile.info.promoted_object_id
      }

      getPromotedObject({ ad_account_id: account.id, promoted_object_type: 'PROMOTED_OBJECT_TYPE_WECHAT_CHANNELS' }).then((data) => {
        this.channelPromotedObjectList = data.map((i) => ({ ...i, icon: i.promoted_object_spec.wechat_channel_spec.icon })) || []
        this.channelId = channelId
      })
    },
    getOfficialAccountList() {
      const { account } = this.rawForm.plan
      const { brand } = this.rawForm.creative?.components || {}
      const { officialAccountInfo } = brand || {}
      // 3.0模板新建回显公众号
      this.officialAccountId = officialAccountInfo?.promoted_object_id || ''
      getPromotedObject({ ad_account_id: account.id, promoted_object_type: 'PROMOTED_OBJECT_TYPE_WECHAT_OFFICIAL_ACCOUNT' }).then(
        (data) => {
          this.officialAccountList = data.map((i) => ({ ...i, icon: i.promoted_object_spec.wechat_official_account_spec.icon })) || []
        }
      )
    },
    onModalClose() {
      this.addProfileModal = false
      this.$refs['add-profile-form'].clearValidate()
    },
    onAddConfirm() {
      this.getProfileList()
    },
    onProfileRowRemove({ profile_id }) {
      this.$confirm('确定要删除该头像昵称吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const { account } = this.rawForm.plan
        delProfiles({
          ad_account_id: account.id,
          profile_id
        }).then((data) => {
          if (data) this.getProfileList()
        })
      })
    },
    showAddModal() {
      this.addProfileModal = true
      const { account, promotedObject } = this.rawForm.plan
      this.addProfileData = { accountId: account.id, promotedObjectId: promotedObject.promoted_object_id }
    },

    showAddBrandModal() {
      const { account } = this.rawForm.plan
      this.addBrandData = { accountId: account.id }
      this.addBrandModal = true
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .profile-radio {
  .el-radio__label {
    > span {
      display: flex;
      align-items: center;
    }
  }
}
</style>
